"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLienAttestationError = exports.LIEN_POSITION_VERIFICATION_CHANGES = exports.OrderedLienAttestationChange = exports.UserLienAttestationType = void 0;
/** @TranslateToPython @TranslateToEnum */
var UserLienAttestationType;
(function (UserLienAttestationType) {
    UserLienAttestationType["FIRST"] = "FIRST";
    UserLienAttestationType["SECOND"] = "SECOND";
    UserLienAttestationType["MULTI_LIEN"] = "MULTI_LIEN";
})(UserLienAttestationType || (exports.UserLienAttestationType = UserLienAttestationType = {}));
/** @TranslateToPython @TranslateToEnum */
var OrderedLienAttestationChange;
(function (OrderedLienAttestationChange) {
    OrderedLienAttestationChange["lessLiens"] = "lessLiens";
    OrderedLienAttestationChange["addedLiens"] = "addedLiens";
    OrderedLienAttestationChange["reorderedLiens"] = "reorderedLiens";
    OrderedLienAttestationChange["updatedMortgageBalanceAmount"] = "updatedMortgageBalanceAmount";
    OrderedLienAttestationChange["updatedMonthlyPaymentAmount"] = "updatedMonthlyPaymentAmount";
    OrderedLienAttestationChange["updatedLienDetails"] = "updatedLienDetails";
    // The first lien was removed, replaced or reordered away, or its balance or monthly payment changed. Recorded
    // alongside the specific changes; an applicant submission requires lien position verification when it is present.
    OrderedLienAttestationChange["changedFirstLien"] = "changedFirstLien";
})(OrderedLienAttestationChange || (exports.OrderedLienAttestationChange = OrderedLienAttestationChange = {}));
/**
 * The recorded changes that mean ops must verify the lien position of an applicant's all-liens attestation: a changed
 * first lien, or any removed lien. Python reads this to decide whether offers carry lienPositionVerification.
 * @TranslateToPython
 */
exports.LIEN_POSITION_VERIFICATION_CHANGES = [OrderedLienAttestationChange.changedFirstLien, OrderedLienAttestationChange.lessLiens];
var UserLienAttestationError;
(function (UserLienAttestationError) {
    UserLienAttestationError["SNAPSHOT_CHANGED"] = "LIEN_ATTESTATION_SNAPSHOT_CHANGED";
})(UserLienAttestationError || (exports.UserLienAttestationError = UserLienAttestationError = {}));
